export default "/images/136a1e5d08e243db2b1b76423ed501c0.avif";